<template>
  <div>
    <el-dialog title="巡检点信息"
      :visible.sync="$parent.editRouter"
      width="30%">
      <el-form :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
        style="width: 80%">
        <el-form-item label="路线名称"
          prop="name">
          <el-input v-model="ruleForm.name"
            placeholder="请输入巡检路线名称"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea"
            v-model="ruleForm.desc"
            placeholder="请输入巡检备注"
            resize="none"
            rows="3"
            maxlength="20"
            show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
        class="dialog-footer">
        <el-button @click="$parent.editRouter = false">取 消</el-button>
        <el-button type="primary"
          @click="submitForm('ruleForm')"
          :loading="btnLoading">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
export default {
  props: ["activeItem"],
  data() {
    return {
      ruleForm: {
        name: "",
        desc: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入巡检路线名称" },
          { whitespace: true, message: "巡检路线名称不能为空" },
          { min: 5, max: 10, message: "请输入 5 到 10 个字", trigger: "blur" },
        ],
      },
      btnLoading: false,
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          return new Promise(async (resolve) => {
            let res = await api.patrolPouteOperation({
              id: this.activeItem.id ? this.activeItem.id : "",
              name: this.ruleForm.name,
              remark: this.ruleForm.desc,
              sourceType: "INSPECTION",
            });
            this.btnLoading = true;
            if (res && res.data.code == 200) {
              this.$message.success("提交成功！");
              this.btnLoading = false;
              this.$parent.editRouter = false;
              this.$store.commit("SET_LOADING", true);
              setTimeout(() => {
                this.$parent.getList();
              }, 1000);
            } else if (res && res.data.code == "00003") {
              this.btnLoading = false;
              this.$message.error(res.data.data);
            }
            resolve();
          });
        } else {
          return false;
        }
      });
    },
    async getDefaultData() {
      let res = await api.patrolPouteGetMsg({ id: this.activeItem.id });
      if (res && res.data.code == 200) {
        this.ruleForm.name = res.data.data.name;
        this.ruleForm.desc = res.data.data.remark;
      }
    },
  },
  created() {
    if (this.activeItem.id) {
      this.getDefaultData();
    }
  },
};
</script>

<style>
</style>